export let UserType = /*#__PURE__*/function (UserType) {
  UserType["STUDENT"] = "student";
  UserType["TEACHER"] = "teacher";
  UserType["PARENT"] = "parent";
  return UserType;
}({});
export let TeacherPosition = /*#__PURE__*/function (TeacherPosition) {
  TeacherPosition["MANAGER"] = "MANAGER";
  TeacherPosition["MAIN"] = "MAIN";
  TeacherPosition["TA"] = "TA";
  return TeacherPosition;
}({});
export let StudentTeacherMappingType = /*#__PURE__*/function (StudentTeacherMappingType) {
  StudentTeacherMappingType["MAIN"] = "MAIN";
  StudentTeacherMappingType["TA"] = "TA";
  return StudentTeacherMappingType;
}({});
export let TeacherStatus = /*#__PURE__*/function (TeacherStatus) {
  TeacherStatus["ACTIVE"] = "ACTIVE";
  TeacherStatus["LEAVE"] = "LEAVE";
  TeacherStatus["QUIT"] = "QUIT";
  return TeacherStatus;
}({});
export let StudentStatus = /*#__PURE__*/function (StudentStatus) {
  StudentStatus["CONSULTING"] = "\uC785\uD559\uBB38\uC758";
  StudentStatus["ENROLLED"] = "\uC7AC\uC6D0";
  StudentStatus["WITHDRAWN"] = "\uD1F4\uC6D0";
  StudentStatus["ON_LEAVE"] = "\uD734\uC6D0";
  return StudentStatus;
}({});
export let StudentWithdrawnReasonCategory = /*#__PURE__*/function (StudentWithdrawnReasonCategory) {
  StudentWithdrawnReasonCategory["NEW_STUDENT_MALADJUSTMENT"] = "NEW_STUDENT_MALADJUSTMENT";
  StudentWithdrawnReasonCategory["ACADEMY_DISSATISFACTION"] = "ACADEMY_DISSATISFACTION";
  StudentWithdrawnReasonCategory["LACK_OF_STUDENT_MOTIVATION"] = "LACK_OF_STUDENT_MOTIVATION";
  StudentWithdrawnReasonCategory["ETC"] = "ETC";
  return StudentWithdrawnReasonCategory;
}({});
export let StatusEventFormFieldKey = /*#__PURE__*/function (StatusEventFormFieldKey) {
  StatusEventFormFieldKey["STATUS"] = "status";
  StatusEventFormFieldKey["REASON_CATEGORY"] = "reasonCategory";
  StatusEventFormFieldKey["REASON"] = "reason";
  StatusEventFormFieldKey["DATE"] = "date";
  return StatusEventFormFieldKey;
}({});